import React from 'react';
const painPoints = [{
  icon: '😴',
  title: 'Sleepless for weeks',
  description: "You've been sleeping in 2-hour blocks for months. The exhaustion is affecting your work, your relationship, and your mental health."
}, {
  icon: '😰',
  title: 'Development anxiety',
  description: 'Are they hitting their milestones? Should they be doing this by now? Constant comparison consumes you every day.'
}, {
  icon: '📱',
  title: 'Contradictory information',
  description: 'You search Google at 3 AM and every result says something different. More information, more confusion.'
}, {
  icon: '💸',
  title: 'Never-ending expenses',
  description: "Toys they don't use, gadgets that promised miracles, and books you never finished reading."
}];
export function PainSection() {
  return <section className="bg-white py-20 px-5" data-id="element-204">
      <div className="max-w-[900px] mx-auto" data-id="element-205">
        {/* Section header */}
        <div className="text-center mb-14" data-id="element-206">
          <span className="inline-block bg-red-50 text-red-400 text-[11px] font-sans font-bold tracking-[2.5px] uppercase py-[7px] px-[18px] rounded-full mb-5" data-id="element-207">
            ⚠️ Does this sound familiar?
          </span>
          <h2 className="text-[clamp(28px,4vw,42px)] text-[#2c1810] leading-[1.25] font-bold font-serif" data-id="element-208">
            The first year is beautiful…
            <br data-id="element-209" />
            <span className="text-[#B76E79] italic font-normal" data-id="element-210">
              but no one told you how hard it would be.
            </span>
          </h2>
        </div>

        {/* Pain points grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-211">
          {painPoints.map((point, idx) => <div key={idx} className="bg-[#faf7f4] border border-[#ede5df] rounded-2xl p-7 flex flex-col gap-3 shadow-[0_2px_12px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-shadow" data-id="element-212">
              <span className="text-3xl" data-id="element-213">{point.icon}</span>
              <h3 className="text-lg font-bold text-[#2c1810] font-sans m-0" data-id="element-214">
                {point.title}
              </h3>
              <p className="text-[15px] leading-[1.75] text-[#5a4a42] font-sans m-0" data-id="element-215">
                {point.description}
              </p>
            </div>)}
        </div>

        {/* Bottom emotional line */}
        <p className="text-center mt-12 text-lg text-[#7a5a50] italic font-serif leading-relaxed max-w-[600px] mx-auto" data-id="element-216">
          "If you feel like you're improvising every single day…{' '}
          <strong className="text-[#2c1810]" data-id="element-217">it's not your fault.</strong> No
          one gave you the manual. Until now."
        </p>
      </div>
    </section>;
}